<template>
  <span
    v-if="pass && showPassFlag"
    class="status-flag"
    :style="'color:' + passFlagColor"
    ><i class="flaticon-flag-2"
  /></span>
</template>

<script>
import { computed } from "vue"
export default {
  name: "PassFlag",
  props: {
    pass: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const passFlagColor = computed(() => {
      if (props.pass && props.pass.badge_flags) {
        if (props.pass.type === "SLP") {
          return "transparent"
        }
        if (props.pass.badge_flags.system_completed) {
          return "#DF3C3B"
        }
        if (props.pass.badge_flags.min_time) {
          return "#F4EA65"
        }
        if (props.pass.badge_flags.extended) {
          return "#672C91"
        }
      }
      return "transparent"
    })

    /** Limit exceeded uses `ri-arrow-up-double-line` elsewhere; hide duplicate flaticon. */
    const showPassFlag = computed(() => {
      const bf = props.pass?.badge_flags
      if (!bf?.limit_exceeded) return true
      return !!(bf.system_completed || bf.min_time || bf.extended)
    })

    return { passFlagColor, showPassFlag }
  }
}
</script>

<style></style>
